import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6803ed7a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6803ed7a&lang=scss"
import style1 from "./index.vue?vue&type=style&index=1&id=6803ed7a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6803ed7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6803ed7a')) {
      api.createRecord('6803ed7a', component.options)
    } else {
      api.reload('6803ed7a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6803ed7a&scoped=true", function () {
      api.rerender('6803ed7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/password/forget/index.vue"
export default component.exports